import React from 'react';

import InventoryDashboard from '@sophocles/views/inventory/components/InventoryDashboard';

function SiteGroupInventoryView(props) {
  return <InventoryDashboard {...props} />;
}

export default SiteGroupInventoryView;
